export enum ApplicationType {
  Construction = 'Construction',
  PrincipalContractor = 'PrincipalContractor',
  Designer = 'Designer',
  PrincialDesigner = 'PrincialDesigner',
  Care = 'Care',
  SSIPApproved = 'SSIPApproved'
}

export enum Location {
  GB = 'GB',
  AU = 'AU'
}

export enum Features {
  SSIP = 'Meet SSIP requirements',
  PAS91 = 'Meet PAS 91 requirements',
  PublicSector = 'Meet public sector requirements',
  CommonAssessment = 'Meet Common Assessment requirements',
  IndustryWide = 'Recognised industry-wide as the most comprehensive'
}

export enum OperationType {
  Renew = 'Renewal',
  Upgrade = 'Upgrade',
  SignUp = 'SignUp',
  ScopeChange = 'ScopeChange'
}

export enum SupportServices {
  SelfServe = 'Self Serve',
  FastTrack = 'Fast Track',
  CHASAssist = 'CHAS Assist'
}

export enum NavigationType {
  Reload = 'reload',
  BackForward = 'back_forward'
}

export enum OrganizationType {
  Contractor = 'Contractor',
  Supplier = 'Supplier'
}
